import { Link } from 'react-router-dom';
import { categoryItems } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3">
            产品中心
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            久久草全系产品
          </h2>
          <p className="max-w-xl mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            从草坪草皮到草种，从绿化服务到养护用品，久久草提供一站式草坪解决方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categoryItems.map((item) => (
            <Link
              key={item.id}
              to="/categories"
              className="group block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-400 hover:border-accent-200 cursor-pointer"
              data-product-shop
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-600 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400"></div>
                <div className="absolute top-3 left-3 w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/90 backdrop-blur-sm">
                  <i className={`${item.icon} text-accent-500 text-lg`}></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors duration-300">
                  {item.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-accent-600 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <span>了解更多</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}